import { Box, Card, CardContent, CircularProgress, Grid, Typography } from "@mui/material";


export const AuthPlaceholder: React.FC = () => {


    return (

        <Grid 
            container
            spacing={0}
            direction="row"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
            gap={2}
        >
            
            <Card>
                <CardContent>
                    <Typography align="center" sx={{color:'rgb(230, 84, 0)', fontWeight:'bold', fontSize:'50px'}}>
                        BHP
                    </Typography>
                    <Typography>
                        Please wait, we are authenticating your request
                    </Typography>
                    <Box display="flex" justifyContent="center">
                        <CircularProgress size="40px" sx={{color: '#e65400'}}/>
                    </Box>
                    
                    
                </CardContent>
            </Card>

        </Grid>

    );
    
};